var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLightingPosition01({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Warstwa_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 16 16",
    style: {
      enableBackground: "new 0 0 16 16"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#1E1E1C;}\n\t.st1{fill:#FFFFFF;}\n\t.st2{fill:#FFFFFF;}\n\t.st3{enable-background:new    ;}\n\t.st4{fill:none;stroke:#FFFFFF;stroke-width:0.5;stroke-miterlimit:10;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M8,14.33c-1.62,0-3.24-0.62-4.48-1.85c-2.47-2.47-2.47-6.49,0-8.96l0,0c2.47-2.47,6.49-2.47,8.96,0 c2.47,2.47,2.47,6.49,0,8.96C11.24,13.71,9.62,14.33,8,14.33z M3.87,3.87c-2.27,2.27-2.27,5.98,0,8.25c2.28,2.27,5.98,2.27,8.25,0 c2.27-2.27,2.27-5.98,0-8.25C9.85,1.6,6.15,1.6,3.87,3.87L3.87,3.87z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLightingPosition01);
export default __webpack_public_path__ + "static/media/LightingPosition-01.e2a885c0adce45a849d897dada4ce4a4.svg";
export { ForwardRef as ReactComponent };